/**
 * Invoice configuration constants.
 * To apply tax in the future, update TAX_RATE here.
 * e.g. 0.05 = 5%, 0.085 = 8.5%
 */
export const TAX_RATE = 0;
